import type { WithActiveBranchId } from '@app/api/shared';
import type { NFiles } from '@app/types';

export enum WarehousesEndpoints {
  UpdateWarehouse = 'UpdateWarehouse',
  SearchWarehouses = 'SearchWarehouses',
  GetWarehouseById = 'GetWarehouseById',
  GetWarehouses = 'GetWarehouses',
  GetBranchWarehouses = 'GetBranchWarehouses',
  GetCurrentBranchWarehouses = 'GetCurrentBranchWarehouses',
  DeleteAllWarehousesData = 'DeleteAllWarehousesData',
  SetProductItemSalePrice = 'SetProductItemSalePrice',
  SetProductSalePriceAndLeftoverControl = 'SetProductSalePriceAndLeftoverControl',
  GetWarehouseProductLeftoverControl = 'GetWarehouseProductLeftoverControl',
  ExportWarehouseProductsToExcel = 'ExportWarehouseProductsToExcel',
}

export interface ModelItem {
  Id: number;
  Name?: string | null;
  IdS?: string | null;
}

export type WarehouseModelItem = ModelItem;

export interface ModelWarehouseFilter {
  SearchTerm: string | null;
  BranchIds: number[] | null;
  ItemsPerPage: number;
  Page: number;
}

export interface ModelWarehousesSearchResult {
  Filter: ModelWarehouseFilter;
  CountItems: number;
  Page: number;
  ItemsPerPage: number;
  Warehouses: ModelWarehouse[] | null;
}

export interface ModelWarehouse {
  Id: number;
  Guid1C?: string | null;
  Name?: string | null;
  Comment?: string | null;
  IsDeleted: boolean;
  BranchIds?: number[] | null;
  CountProducts: number;
  IsDefault: boolean;
}

export interface GetWarehouseByIdParams {
  warehouseId: number;
}

export interface GetWarehousesParams {
  warehouseId?: number;
}

export interface GetBranchWarehousesParams {
  branchId?: number;
  warehouseId?: number;
}

export interface ExportWarehouseProductsToExcelParams {
  warehouseId?: number;
}

export type GetWarehousesRequest = WithActiveBranchId<GetWarehousesParams>;

export type UpdateWarehouseRequest = WithActiveBranchId<{
  data: ModelWarehouse;
}>;

export type SearchWarehousesRequest = WithActiveBranchId<{
  data: ModelWarehouseFilter;
}>;

export type GetWarehouseByIdRequest =
  WithActiveBranchId<GetWarehouseByIdParams>;

export type GetBranchWarehousesRequest =
  WithActiveBranchId<GetBranchWarehousesParams>;

export type GetCurrentBranchWarehousesRequest = WithActiveBranchId;
export type ExportWarehouseProductsToExcelRequest =
  WithActiveBranchId<ExportWarehouseProductsToExcelParams>;

export type SearchWarehousesResponse = ModelWarehousesSearchResult;
export type UpdateWarehouseResponse = ModelWarehouse;
export type GetWarehouseByIdResponse = ModelWarehouse;
export type GetWarehousesResponse = ModelWarehouse[];
export type GetBranchWarehousesResponse = ModelItem[];
export type GetCurrentBranchWarehousesResponse = ModelWarehouse[];
export type DeleteAllWarehousesDataRequest = WithActiveBranchId;
export type DeleteAllWarehousesDataResponse = void;
export type ExportWarehouseProductsToExcelResponse = NFiles.ModelFile;

export interface ModelProductSalePriceAndLeftovers {
  ProductId: number;
  WarehouseId: number;
  IsSetSalePrice: boolean;
  PriceChangeType?: string | null;
  SalePrice?: number | null;
  IsSetLeftoverControl: boolean;
  LeftoverMinimal?: number | null;
  IsNotifyAtMinimal: boolean;
  LeftoverCritical?: number | null;
  IsNotifyAtCritical: boolean;
}

export interface ModelProductLimits {
  WarehouseId: number;
  ProductId: number;
  CountMinimal?: number | null;
  CountCritical?: number | null;
  IsNotifyMinimal: boolean;
  IsNotifyCritical: boolean;
}

export interface SetProductItemSalePriceParams {
  ProductItemId: number;
  SalePrice: number;
}

export interface GetWarehouseProductLeftoverControlParams {
  warehouseId: number;
  productId: number;
}

export type SetProductItemSalePriceRequest =
  WithActiveBranchId<SetProductItemSalePriceParams>;
export type SetProductItemSalePriceResponse = void;

export type SetProductSalePriceAndLeftoverControlRequest = WithActiveBranchId<{
  data: ModelProductSalePriceAndLeftovers;
}>;
export type SetProductSalePriceAndLeftoverControlResponse = void;

export type GetWarehouseProductLeftoverControlRequest =
  WithActiveBranchId<GetWarehouseProductLeftoverControlParams>;
export type GetWarehouseProductLeftoverControlResponse = ModelProductLimits;
